import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheckCircle } from 'react-icons/fa';
import { trackEvent } from '../utils/analytics';
import {
  CTA_PRIMARY_LABEL,
  CTA_PRIMARY_PATH,
  CTA_SECONDARY_LABEL,
  CTA_SECONDARY_PATH,
} from '../constants/cta';

const SolutionLanding = ({ title, subtitle, outcomes, stack, ctaPath }) => {
  return (
    <div className="solution-landing">
      <section className="hero">
        <div className="container">
          <h1>{title}</h1>
          <p>{subtitle}</p>
          <div className="hero-cta">
            <Link
              to={ctaPath || CTA_PRIMARY_PATH}
              className="btn btn-primary btn-large"
              onClick={() => trackEvent('landing_cta_click', { landing: title, cta: 'primary' })}
            >
              {CTA_PRIMARY_LABEL} <FaArrowRight className="btn-icon" />
            </Link>
            <Link
              to={CTA_SECONDARY_PATH}
              className="btn btn-secondary btn-large"
              onClick={() => trackEvent('landing_cta_click', { landing: title, cta: 'secondary' })}
            >
              {CTA_SECONDARY_LABEL}
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">What You Get</h2>
          <div className="grid grid-3">
            {outcomes.map((item) => (
              <article className="card" key={item}>
                <h3><FaCheckCircle /> {item}</h3>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">Technology Stack We Use</h2>
          <div className="service-features">
            {stack.map((item) => (
              <span className="service-feature" key={item}>{item}</span>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SolutionLanding;
